<template>
    <div id="app">
      <div v-if="defaultHeader">
        <site-header />
      </div>
      <loader v-if="showLoading"></loader>
      <router-view/>
      <div v-if="defaultFooter">
        <site-footer />
      </div>
      <location-permission />
      <leads-storage />
      <notifications></notifications>
    </div>
</template>

<script>
import SiteHeader from './components/SiteHeader.vue'
import SiteFooter from './components/SiteFooter.vue'
import loader from './components/LoaderGlobal.vue'
import LocationPermission from './components/LocationPermission.vue'
import LeadsStorage from './components/lead-storage/LeadsStorage.vue'
import { mapState } from 'vuex';
import { baseUrl, Domain } from './config/config'
export default {
  components: {
    SiteHeader,
    SiteFooter,
    loader,
    LocationPermission,
    LeadsStorage,
  },
  mounted () {
    this.FetchColorCodeInfo();
    this.renderFavIcon();
    this.disableGoogleTranslate();
    this.setThemeColor();
  },
  data(){
    return{
      defaultHeader: true,
      defaultFooter: true,
    }
  },
  methods: {
    FetchColorCodeInfo () {
      console.log('*** FetchColorCode ***')
      // let siteDomain = window.btoa(unescape(encodeURIComponent('https://enroll.purenroll.com')))
      let siteDomain = window.btoa(unescape(encodeURIComponent(Domain)))
      let app = this
      // let siteDomain = 'aHR0cHM6Ly9lbnJvbGwucHVyZW5yb2xsLmNvbQ=='
      let url = `${baseUrl}/api/v1/get-external-site-dynamic-information?site_domain=${siteDomain}`
      // passing request object
      let req = new Request(url, {
        method: 'GET',
        headers: {
          'Content-Type': process.env.VUE_APP_CONTENT_TYPE,
          'Authorization': process.env.VUE_APP_AUTHORIZATION
        },
        mode: 'cors'
      })
      // Using fetch api javascript in built library for api req
      fetch(req)
          .then(response => {
            response.json().then(data => {
              // this.getCatchColor = JSON.stringify(data.data)
              // console.log('fetch response', JSON.stringify(data.data))

              // Creating cache name fetch_color_cache
              caches.open('fetch_color_cache').then((cache) => {
                // Converting response send as promise to Json object.
                const jsonResponse = new Response(JSON.stringify(data.data));
                // Storing the response on created catch
                cache.put(req, jsonResponse);
                app.$store.dispatch("themeColorList", JSON.stringify(data.data));
                app.setThemeColor()
              }).catch((err) => {
                console.log(err);
              })

            })
          })
          .catch(error => {
            console.log(error);
          });
    },
    renderFavIcon() {
      if (process.env.VUE_APP_IS_GO_ENROLL == 'true') {
        let favicon = document.getElementById("favicon");
        favicon.href = 'goenroll-fav.ico'
        document.title = 'GO ENROLL 123'
      } else {
        let favicon = document.getElementById("favicon");
        favicon.href = 'favicon.png'
        document.title = 'Easiest Enrollment System - Corenroll'
      }
    },
    disableGoogleTranslate () {
     if (process.env.VUE_APP_IS_GO_ENROLL == 'false') {
       let element = document.getElementById('google_translate_element');
       element.style.display = 'none'
     }
    },
    setThemeColor() {
      let app = this
      try {
        let themeColorArray = app.themeColorList
        const colorArray = JSON.parse(themeColorArray);
        const themeColors = {};
        const root = document.documentElement;
        colorArray?.forEach(item => {
          if (item?.key && item?.value !== undefined) {
            themeColors[item.key] = item.value;
          }
        });
        root.style.setProperty('--brand-color', themeColors["VUE_APP_PRIMARY"]);
        root.style.setProperty('--footer-primary-color', themeColors["VUE_APP_FOOTER_PRIMARY_COLOR"]);
        root.style.setProperty('--top-header-primary-color', themeColors["VUE_APP_TOP_HEADER_COLOR"]);
        root.style.setProperty('--top-header-font-color', themeColors["VUE_APP_TOP_HEADER_FONT_COLOR"]);
        root.style.setProperty('--nav-primary-color', themeColors["VUE_APP_NAV_PRIMARY_COLOR"]);
        root.style.setProperty('--nav-color', themeColors["VUE_APP_NAV_COLOR"]);
        root.style.setProperty('--dark-btn', themeColors["VUE_APP_DARK_BTN"]);
        root.style.setProperty('--dark-btn-color', themeColors["VUE_APP_DARK_BTN_COLOR"]);
        root.style.setProperty('--brand-btn', themeColors["VUE_APP_BRAND_BTN"]);
        root.style.setProperty('--brand-btn-color', themeColors["VUE_APP_BRAND_BTN_COLOR"]);
        root.style.setProperty('--card-bandage-color', themeColors["VUE_APP_CARD_BANDAGE_COLOR"]);
        root.style.setProperty('--error-message-color', themeColors["VUE_APP_ERROR_MESSAGE_COLOR"]);
        root.style.setProperty('--font-family', themeColors["VUE_APP_FONT_FAMILY"]);
        root.style.setProperty('--font-header', themeColors["VUE_APP_FONT_HEADER"]);
        root.style.setProperty('--background-color', themeColors["VUE_APP_BACKGROUND"]);
        root.style.setProperty('--btn', themeColors["VUE_APP_BTN"]);
        root.style.setProperty('--tableth', '#333333');
        root.style.setProperty('--footer-link', themeColors["VUE_APP_FOOTER_LINK"]);
        root.style.setProperty('--multiple-tag', themeColors["VUE_APP_MULTIPLE_TAG"]);
        root.style.setProperty('--cart-btn-background', themeColors["VUE_APP_CART_BTN_BACKGROUND"]);
        root.style.setProperty('--cart-btn-color', themeColors["VUE_APP_CART_BTN"]);
        root.style.setProperty('--order-info-card-background', themeColors["VUE_APP_ORDER_INFO_CARD"]);
        root.style.setProperty('--card-btn-delete-background', themeColors["VUE_APP_CARD_BTN_DELETE_BACKGROUND"]);
        root.style.setProperty('--card-btn-delete-color', themeColors["VUE_APP_CARD_BTN_DELETE"]);
        root.style.setProperty('--card-btn-hover', themeColors["VUE_APP_CARD_BTN_HOVER"]);
      } catch (error) {
        console.error(error);
      }
    }
  },
  watch: {
    "$route.params": {
      handler() {
        if (this.$route.name == "error" || this.$route.name == "landing-config-error") {
          this.defaultHeader = false;
          this.defaultFooter = false;
        } else {
          this.defaultHeader = true;
          this.defaultFooter = true;
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState({
      showLoading: state => state.showLoading
    }),
    themeColorList () {
      return this.$store.getters.themeColorList
    }
  }
}
</script>

<style>
@import url('assets/fonts/stylesheet.css');
@import url('assets/css/common.css');
#app {
  font-family: 'Raleway' !important;
}
body{
  background-color: #f3f8fa !important;
  position: relative;
}
body::before{
  content: '';
  position: absolute;
  background: url(./assets/body-bg.png) no-repeat;
  width: 100%;
  height: 100%;
  background-size: inherit;
  min-height: 100vh;
  background-position: right top;
  z-index: -1;
  background-attachment: fixed;
}
a, a:hover{
  color: inherit;
  text-decoration: none !important;
}
</style>

<style lang="scss" >
    //#app {
    //    font-family: Avenir, Helvetica, Arial, sans-serif;
    //    -webkit-font-smoothing: antialiased;
    //    -moz-osx-font-smoothing: grayscale;
    //    text-align: center;
    //    color: #2c3e50;
    //}
    // @import "css/common.css";
    // @import "css/index.css";
    /*@import "css/main.css";*/
    //@import "css/plan_desc.css";
    //@import "scss/main";

    // @import "assets/scss/main.scss";
    .vue-notifyjs {
      .alert {
        z-index: 1080 !important;
        &.alert-with-icon {
          padding-left: 25px !important;
        }
        .alert-icon {
          margin-right: 15px !important;
        }
        .close ~ span {
          display: inline-block !important;
        }
      }
    }
</style>
